import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CubicleOption, CubicleOptionValue} from "../../../../shared/model/cubicleOption-model";
import {Range} from "../../../../shared/model/range-model";
import {TreeNode, TreeTableNode} from "primeng/api";
import {Status} from "../../../../project/shared/project-model";
import {option} from "@se/web-ui/types/components/checkbox/constants";

@Component({
  standalone: false,
  selector: 'app-odm-options-list',
  templateUrl: './odm-options-list.component.html',
  styleUrls: ['./odm-options-list.component.scss']
})
export class OdmOptionsListComponent implements OnInit, OnChanges {

  @Input()
  activeOption: string;

  @Input()
  options: CubicleOption[];

  @Input()
  showOnPopUpStatus: boolean = true;

  @Input()
  selectedRange: Range;

  @Output()
  clickEditOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickDeleteOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickCopyOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickEditOptionValueButton: EventEmitter<{
    option: CubicleOption,
    optionValue: CubicleOptionValue
  }> = new EventEmitter<{ option: CubicleOption, optionValue: CubicleOptionValue }>();
  @Output()
  clickDeleteOptionValueButton: EventEmitter<{
    option: CubicleOption,
    optionValue: CubicleOptionValue
  }> = new EventEmitter<{ option: CubicleOption, optionValue: CubicleOptionValue }>();
  @Output()
  changeOptionValueOrderEvent: EventEmitter<{
    optionId: string,
    optionValueName: string,
    currentIndex: number
  }> = new EventEmitter<{ optionId: string, optionValueName: string, currentIndex: number }>();
  optionsData: TreeNode[] = [];
  cols = [
    {label: 'T_OPTIONS_TITLE', field: 'name', styleClass: 'text-left col-1 col-category'},
    {label: 'T_OFFER_DATA_MANAGEMENT_OPTION_VALUE_INFORMATION', field: 'valueName', styleClass: 'text-left col-1'},
    {label: 'T_OPTION_VALUE_REFERENCE', field: 'reference', styleClass: 'text-left col-1'}
  ];
  toExpand = true;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
        if (changes.options) {
            this.createOptionsNode();
        }
    }

  ngOnInit(): void {
    this.createOptionsNode();
    }


  onClickEditOptionButton(node: TreeTableNode) {
      this.clickEditOptionButton.emit(this.getCubicleOptionFromOptionNode(node));
  }

  onClickDeleteOptionButton(node: TreeTableNode) {
      this.clickDeleteOptionButton.emit(this.getCubicleOptionFromOptionNode(node));
  }

  onClickCopyOptionButton(node: TreeTableNode) {
      this.clickCopyOptionButton.emit(this.getCubicleOptionFromOptionNode(node));
  }

  onClickEditOptionValueButton(node: TreeTableNode) {
    const cubicleOptionFromNode: CubicleOption = this.getCubicleOptionFromValueNode(node);
    this.clickEditOptionValueButton.emit({option: cubicleOptionFromNode, optionValue: this.getValueFromValueNode(node,cubicleOptionFromNode)});
  }

  onClickDeleteOptionValueButton(node: TreeTableNode) {
    const cubicleOptionFromNode: CubicleOption = this.getCubicleOptionFromValueNode(node);
    this.clickDeleteOptionValueButton.emit({option: cubicleOptionFromNode, optionValue: this.getValueFromValueNode(node,cubicleOptionFromNode)});
  }

  isEditable(node: any): boolean {
    return node.reference !== null;
  }

  public isExpanded(node: any): boolean {
    return node.parent === null && node.node !== null && node.node.expanded === true;
  }

  public showOptionActions(node: any):boolean{
    return node.name !== null;
  }

  public showOptionValueActions(node: any):boolean{
    return !this.showOptionActions(node) ;
  }

  public toggleExpand() {
    if (this.optionsData && this.optionsData.length > 0) {
      const newOptionData = [...this.optionsData];
      newOptionData.forEach(optionData =>{
        optionData.expanded =  this.toExpand ;
      } )
      this.optionsData = newOptionData;
      this.toExpand= !this.toExpand;
    }
  }

  private getCubicleOptionFromOptionNode(node: TreeTableNode<any>): CubicleOption {
    if (node.node !== null && node.node.data !== null && node.node.data.id !== null) {
      return  this.options.find(option => option.id === node.node.data.id);
    }
    return null;
  }

  private getValueFromValueNode(node: any, cubicleOptionFromNode: CubicleOption) {
    if (node.valueName !== null ) {
      return cubicleOptionFromNode.values.find(value => value.value === node.valueName);
    }
  }

  private getCubicleOptionFromValueNode(node: any): CubicleOption {
    if (node.id !== null) {
      return  this.options.find(option => option.id === node.id);
    }
    return null;
  }


  private  createOptionsNode() {
    let treeNodes: TreeNode[] = [];
    this.options.forEach(option => treeNodes.push(this.createOptionNode(option)));
    this.optionsData = treeNodes;
    this.toExpand = true;
  }

  private  createOptionNode(option: CubicleOption): TreeNode {
    const expanded = this.activeOption === option.id;
    const values = option.values ? option.values : [];
    const hasAtLeastOneReferencedValue = values.some(value =>
      value && value.reference && value.reference.ref && value.reference.ref.trim().length > 0
    );
    const isValid = !option.mandatory || (values.length >= 2 && hasAtLeastOneReferencedValue);

    const hasOptionValueWarning = !option.mandatory && !hasAtLeastOneReferencedValue;

    return {
      data: {id: option.id, name: option.name, description: option.description, mandatory: option.mandatory, onPopUp: option.onPopUp, reference: null,isValid: isValid, hasOptionValueWarning},
      type: 'option',
      expanded: expanded,
      leaf: false,
      children: this.createOptionValuesNode(option.values, option.id)
    };
  }

  private  createOptionValuesNode(values: CubicleOptionValue[], optionId: string): TreeNode[] {
    let treeNodes: TreeNode[] = [];
    if (values === null) {
      return [];
    }

    values
      .sort((a, b) =>  (a.orderIndex> b.orderIndex ? 1 : -1))
      .forEach(value => {
      let reference: string;
      if (value.reference === null || value.reference.ref === null) {
        reference = null;
      } else {
        reference = value.reference.ref;
      }

      let description: string;
      if (value.reference === null || value.reference.description === null) {
        description = null;
      } else {
        description = value.reference.description;
      }
      treeNodes.push({
        data: {id: optionId, name: null, valueName: value.value, valueDescription: description ,reference: reference},
        type: 'reference',
        children: []
      });
    });
    return treeNodes;
  }

  onChangeOrderOptionValue(move: string, node: TreeTableNode) {

    const cubicleOptionFromNode: CubicleOption = this.getCubicleOptionFromValueNode(node);
    if(cubicleOptionFromNode === null) {
      return
    }
    const value = this.getValueFromValueNode(node,cubicleOptionFromNode);
    if(value === null) {
      return
    }
    let index;
    if (move === 'up') {
      index =value.orderIndex - 1;
    } else if (move === 'down') {
      index =value.orderIndex + 1;
    } else {
      return;
    }

      this.changeOptionValueOrderEvent.emit({
        optionId: cubicleOptionFromNode.id,
        optionValueName: value.value,
        currentIndex: index,
      });

  }


  protected readonly status = Status;
}

